import { DependenciesInjection } from "app/di/DependencyInjection";
import { AppProfileRegisterRepositoryImpl } from "../data/AppProfileImpl";
import { IAppProfileRepository } from "../domain/repositories/IAppProfileRepository";
import { AppProfileUseCase } from "../domain/useCases/AppProfileUseCase";
import { AppProfileViewModel } from "../presentation/viewModel/AppProfileViewModel";
import { AppProfileToken } from "./AppProfileToken";

export class AppProfileInjection {
  static initInjection() {
    DependenciesInjection.register<IAppProfileRepository>(
      AppProfileToken.IAppProfileRepository,
      AppProfileRegisterRepositoryImpl,
      "otherRepo",
    );
    DependenciesInjection.register<AppProfileUseCase>(
      AppProfileToken.AppProfileUseCase,
      AppProfileUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<AppProfileViewModel>(
      AppProfileToken.AppProfileViewModel,
      AppProfileViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IAppProfileRepository>(
      AppProfileToken.IAppProfileRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<AppProfileUseCase>(
      AppProfileToken.AppProfileUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<AppProfileViewModel>(
      AppProfileToken.AppProfileViewModel,
    );
  }
}
